import axios from "axios";
import qs from "qs";
import Storage from "../utils/Storage";
import Config from "../config";
import { getToken } from "./service";

/**
 * 生成邀请码
 */
export function createInvitationCode(courseNo: string, courseSeq: string) {
    return axios.post(
        `/teacher/createInvitationCode`,
        qs.stringify({ courseNo, courseSeq })
    );
}

export interface CourseInvitationListItem {
    createTime: string; //加入时间
    subject: string; //专业
    sex: string; //性别
    name: string; //姓名
    studentNo: string; //学号
    className: string; //班级
    department: string; //学院
}

/**
 * 邀请记录列表
 */
export function getStuCourseInvitationList(
    courseNo: string,
    courseSeq: string,
    search?: string
) {
    const searchParams = search?.trim();
    const token = getToken();
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios
        .post<SuccessData<CourseInvitationListItem[]>>(
            `/teacher/getStuCourseInvitationList`,
            qs.stringify({ courseNo, courseSeq, search: searchParams }),
            { headers: { token, batchNo } }
        )
        .then(data => data.data.data);
}

/**
 * 移除通过邀请码加入的学生
 */
export function removeStuCourse(
    courseNo: string,
    courseSeq: string,
    studentNo: string
) {
    return axios.post(
        `/teacher/removeStuCourse`,
        qs.stringify({ courseNo, courseSeq, studentNo })
    );
}

/**
 * 停用邀请码
 */
export function stopStuCourseInvitation(joinInCode: string) {
    return axios.post(
        `/teacher/stopStuCourseInvitation`,
        qs.stringify({ joinInCode })
    );
}

/**
 * 反查邀请码
 */
export function getCourseInvitation(courseNo: string, courseSeq: string) {
    return axios
        .post(
            `/teacher/getCourseInvitation`,
            qs.stringify({ courseNo, courseSeq })
        )
        .then(data => data.data.message);
}
